<template>
<!-- 销售管理 -->
<el-drawer title="人员管理" size="45%" :visible.sync="isShow" :with-header="true">
  <div class="drawer-form">
    <!-- <i class="el-icon-plus"></i> -->
    <el-button type="primary" style="margin-bottom: 10px" @click="appendStaff">+ 新增</el-button>
    <el-table :data="staffData" style="width: 100%">
      <el-table-column prop="realname" label="人员姓名"></el-table-column>
      <el-table-column label="商户角色">
        <template slot-scope="scope">
          <el-link v-if="scope.row.role=='1'">管理员</el-link>
          <el-link v-if="scope.row.role=='0'">销售</el-link>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template slot-scope="scope">
          <div>
            <el-button type="primary" @click="unbindStaff(scope.row)">解绑</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
  <bind-staff ref="bindStaff" :parent="_self"></bind-staff>
</el-drawer>
</template>

<script>
import bindStaff from './bindStaff.vue'

export default {
  components: {
    bindStaff
  },
  data() {
    return {
      hotel_id: 0,
      isShow: false,
      staffData: [],
    };
  },
  methods: {
    // 销售管理
    show(row) {
      this.hotel_id = row.id;
      this.isShow = true;
      this.getBindedStaff(row.id);
    },
    getBindedStaff(hotelId) {
      let url = '/api/merchant.user/companyUser';
      this.$post(url, {
      //  hotel_id: "100",
       hotel_id: hotelId
      }).then(res => {
        this.staffData = res.data.users;
      });
    },
    // 删除销售
    unbindStaff(row) {
      let _this = this;
      this.$confirm('确定解绑此人员吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          let url = '/api/merchant.user/unbindCompanyUser';
          _this.$post(url, {
            user_id: row.id,
            hotel_id: _this.hotel_id
          }).then(res => {
            _this.staffData.forEach((item, key) => {
              if (row.id == item.id) {
                _this.staffData.splice(key, 1);
              }
            });

            _this.$message({
              type: 'success',
              message: res.msg
            });
          });
        })
        .catch(() => {
          _this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    // 添加销售
    appendStaff() {
      if(this.$refs['bindStaff']) {
        this.$refs['bindStaff'].show(this.hotel_id);
      } else {
        this.$nextTick(function() {
          this.$refs['bindStaff'].show(this.hotel_id);
        })
      }
    },
  }
}
</script>
<style lang="less">
@import url('@/assets/css/drawer.less');
</style>